export const CropMarks = ({ color = "#C0C0C0", offset = 12, length = 14, opacity = 0.45 }) => {
  const stroke = { stroke: color, strokeWidth: 1, opacity };
  return (
    <>
      {/* top-left */}
      <span
        aria-hidden
        style={{
          position: "absolute",
          top: offset,
          left: offset,
          width: length,
          height: 1,
          background: color,
          opacity,
        }}
      />
      <span
        aria-hidden
        style={{
          position: "absolute",
          top: offset,
          left: offset,
          width: 1,
          height: length,
          background: color,
          opacity,
        }}
      />
      {/* top-right */}
      <span
        aria-hidden
        style={{
          position: "absolute",
          top: offset,
          right: offset,
          width: length,
          height: 1,
          background: color,
          opacity,
        }}
      />
      <span
        aria-hidden
        style={{
          position: "absolute",
          top: offset,
          right: offset,
          width: 1,
          height: length,
          background: color,
          opacity,
        }}
      />
      {/* bottom-left */}
      <span
        aria-hidden
        style={{
          position: "absolute",
          bottom: offset,
          left: offset,
          width: length,
          height: 1,
          background: color,
          opacity,
        }}
      />
      <span
        aria-hidden
        style={{
          position: "absolute",
          bottom: offset,
          left: offset,
          width: 1,
          height: length,
          background: color,
          opacity,
        }}
      />
      {/* bottom-right */}
      <span
        aria-hidden
        style={{
          position: "absolute",
          bottom: offset,
          right: offset,
          width: length,
          height: 1,
          background: color,
          opacity,
        }}
      />
      <span
        aria-hidden
        style={{
          position: "absolute",
          bottom: offset,
          right: offset,
          width: 1,
          height: length,
          background: color,
          opacity,
        }}
      />
    </>
  );
};

export const RegistrationDot = ({ size = 14, color = "#B89B5E", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    className={className}
    aria-hidden
  >
    <circle cx="7" cy="7" r="6" stroke={color} strokeWidth="1" />
    <line x1="0" y1="7" x2="14" y2="7" stroke={color} strokeWidth="1" />
    <line x1="7" y1="0" x2="7" y2="14" stroke={color} strokeWidth="1" />
  </svg>
);

export const MicroLabel = ({ children, index, accent = "#B89B5E", className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span
      aria-hidden
      style={{ width: 22, height: 1, background: accent, opacity: 0.85 }}
    />
    {index !== undefined && (
      <span
        className="ko-overline"
        style={{ color: accent, fontVariantNumeric: "tabular-nums" }}
      >
        {String(index).padStart(2, "0")}
      </span>
    )}
    <span className="ko-overline" style={{ color: accent }}>
      {children}
    </span>
  </div>
);

export default CropMarks;
